import { Config } from '@muz/jobboard-vue-client/src/config';

const customConfig = {
    criteria: {
        state: {
            // Show only german job ads
            'PublicationLanguage.Code': ['1'],
        },
    },
    params: {
        state: {
            sortBy: 'PositionStartDateInitial',
        },
    },
    loginPage: {
        supportHref:
            'https://keycloak.service.beesite.de/auth/realms/Toolbox/login-actions/reset-credentials',
        helpDeskMailHref: 'mailto:support@jobstairs.de',
    },
    tokenService: {
        baseURL: 'https://keycloak.service.beesite.de',
        endpoint: '/auth/realms/Toolbox/protocol/openid-connect/token',
        clientId: 'jobstairs_tools',
        scope: 'openid',
    },
    titleAnalysis: {
        baseURL: 'https://title-tune-api.app.beesite.de',
        endpoint: '/rating',
    },
    titleTune: {
        baseURL: 'https://title-tune-api.app.beesite.de',
        endpoints: {
            generate: '/generator',
            feedback: '/feedback',
        },
    },
    recruitomat: {
        baseURL: 'https://recruitomat-api.app.beesite.de',
        endpoints: {
            analysis: '/analysis',
            prediction: '/prediction',
        },
    },
    requirements: {
        baseURL: 'https://jobad-insights-api.app.beesite.de',
        endpoints: {
            analysisById: '/entity_extraction',
            freetextAnalysis: '/entity_extraction',
        },
    },
    readability: {
        baseURL: 'https://readability-api.app.beesite.de',
        endpoint: '/analysis/readability',
    },
    companyStatistics: {
        baseURL: 'https://company-statistics-api.app.beesite.de/',
        endpoint: '/statistics',
    },
    jobAd: {
        baseURL: 'https://readability-api.app.beesite.de',
        endpoint: '/analysis/inclusivity',
        idProperty: 'ID',
        externalIdProperty: 'PositionIDCustom',
        companyProperty: 'ParentOrganization',
        properties: ['OrganizationName', 'ParentOrganization', 'PositionTitle'],
    },
    aiWriterOptimize: {
        baseURL: 'https://ai-writer-api.app.beesite.de',
        endpoint: '/optimize',
    },
    keys: {
        key: 'ID',
        title: 'PositionTitle',
        organization: 'OrganizationName',
    },
    beesiteJobAds: {
        baseURL:
            process.env.BETTERADS_JOBAD_STORAGE ||
            'https://gateway-betterads.app.beesite.de',
        endpoint: '/jobad',
    },
};

export default Config(customConfig);
